import { PageHero } from "@/components/PageHero";

const CONTENT = {
  privacy: {
    overline: "Legal",
    title: "Privacy Policy",
    sub: "How Color Crate Moving collects, uses, and protects your information.",
    body: [
      ["Information We Collect", "We collect the information you provide when reserving totes or contacting us — including your name, phone number, email address, and moving details. We use this solely to fulfill your rental and communicate with you."],
      ["How We Use It", "Your information is used to process reservations, coordinate delivery and pickup, send confirmations, and respond to inquiries. We never sell your personal data to third parties."],
      ["Data Security", "We take reasonable measures to protect your information. Reservation details are stored securely and accessed only by authorized team members."],
      ["Contact", "Questions about your privacy? Email us at info.colorcratemoving@gmail.com."],
    ],
  },
  terms: {
    overline: "Legal",
    title: "Terms of Service",
    sub: "The terms that govern your rental with Color Crate Moving.",
    body: [
      ["Rentals", "Rental periods and tote quantities are defined by your selected package. Extended rentals may incur additional weekly charges."],
      ["Delivery & Pickup", "We deliver and pick up totes within our published Iowa service area. You are responsible for providing accurate delivery and pickup addresses and reasonable access."],
      ["Care of Totes", "Totes remain the property of Color Crate Moving. Please avoid damage beyond normal wear. Lost or significantly damaged totes may be billed at replacement cost."],
      ["Cancellations", "Reservations may be modified or cancelled prior to delivery. Contact us as early as possible to reschedule."],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type];
  return (
    <div data-testid={`legal-${type}`}>
      <PageHero overline={c.overline} title={c.title} subtitle={c.sub} />
      <section className="mx-auto max-w-3xl px-6 md:px-12 pb-24 md:pb-32 space-y-10">
        {c.body.map(([h, p]) => (
          <div key={h}>
            <h2 className="font-heading font-bold text-2xl text-white">{h}</h2>
            <p className="mt-3 text-white/60 leading-relaxed">{p}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
